import React from 'react'



export default function GiftCard({ cata }) {

    
    const bekaxalat=(item)=>{
        console.log(item)
        localStorage.removeItem('gift');
        localStorage.setItem('gift', JSON.stringify(item.Pimg));
    }

    
    


    return (
        <div className='p-5 border-t-2 '>
            <div className='flex flex-col md:flex-row flex-wrap'>
                {cata.map((item) => {
                    return (
                        <div className="border-2  h-fit my-4 w-full lg:w-1/3 mx-auto max-w-xs border-shasham hover:border-yakam bg-dwam shadow-xl rounded-lg ">



                            <div className="px-4 py-2">
                                <h1 className="text-3xl text-center font-bold text-yakam uppercase drop-shadow-lg">{item.Ptitle}</h1>
                            </div>

                            <div  className='bg-white backdrop-blur-3xl bg-opacity-50 p-3' >
                                <img className=" drop-shadow-2xl object-contain w-full h-48 mt-2" src={item.Pimg} alt={item.Pimg} />
                                
                            </div>

                            <div className="flex items-center justify-between px-4 py-2 w-full backdrop-blur-xl rounded-b-md bg-opacity-70 bg-chwaram">
                                <h1 className=" text-2xl font-bold text-shasham">{item.price}$</h1>
                                <button onClick={()=>{bekaxalat(item)}} className="px-2 py-1 text-sm flex items-center font-medium text-yakam uppercase transition-colors duration-200 transform backdrop-blur-xl  bg-opacity-60 bg-white rounded hover:bg-teal-200 ">
                                    بیکە بەخاڵات
                                </button>

                            </div>

                        </div>

                    )
                })}
            </div>
            
        </div>
    )
}

